module.exports = __webpack_public_path__ + "img/ad.00fa1255.png";